import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import { translations } from 'i18n';
import { triggerAppSync, triggerWifiConnect } from 'actions/gallery';
import { triggerContinueInstall } from 'actions/install-flow';

export const stateToProps = ({ continueInstall, requiresWifi }) => ({
  installFlow: {
    requiresWifi
  },
  continueInstall: {
    show: continueInstall.show && !continueInstall.hasBeenSeen
  }
});

export const dispatchToProps = (dispatch) => ({
  async triggerSync(installFlow) {
    await dispatch(
      triggerContinueInstall({
        show: false,
        hasBeenSeen: true,
        shouldContinue: true
      })
    );

    if (installFlow.requiresWifi) {
      try {
        await dispatch(triggerWifiConnect());
      } catch (error) {
        return;
      }
    }

    return dispatch(triggerAppSync({ requiresWifi: installFlow.requiresWifi }));
  },
  // TODO Originally planned to removed in progress apps when user cancels
  // but with most apps being required the logic would not work well
  async triggerRemove() {
    await dispatch(
      triggerContinueInstall({
        show: false,
        hasBeenSeen: true,
        shouldContinue: false
      })
    );
  }
});

export default class ContinueInstallModal extends Component {
  static propTypes = {
    installFlow: PropTypes.shape({
      requiresWifi: PropTypes.bool
    }).isRequired,
    continueInstall: PropTypes.shape({
      show: PropTypes.bool,
      hasBeenSeen: PropTypes.bool,
      shouldContinue: PropTypes.bool
    }).isRequired,
    triggerSync: PropTypes.func.isRequired,
    triggerRemove: PropTypes.func.isRequired
  };

  sync = () => {
    this.props.triggerSync(this.props.installFlow);
  };

  remove = () => {
    this.props.triggerRemove();
  };

  render() {
    const {
      component: {
        ContinueInstallModal: {
          title,
          text,
          continueButtonText,
          cancelButtonText
        }
      }
    } = translations;
    return (
      <Modal
        id="ContinueInstallModal"
        title={title()}
        contentAbove={text()}
        onClose={this.remove}
        buttons={[
          {
            text: cancelButtonText(),
            id: 'cancel-wait-button',
            onClick: this.remove
          },
          {
            highlight: true,
            text: continueButtonText(),
            id: 'ok-wait-button',
            onClick: this.sync
          }
        ]}
      />
    );
  }
}
